export const NotificationsKeys = {
	all: ['notifications'] as const,
	new: () => [...NotificationsKeys.all, 'new'] as const,
	userAll: (id:number) => [...NotificationsKeys.all, `${id}`] as const,
	userNew: (id:number) => [...NotificationsKeys.new(), `${id}`] as const
};